// Add your JS customizations here
jQuery(document).ready(function($) {
	// Initiate WOW Animations
	new WOW().init();


	// Main Menu — scroll and menu active state
	function checkScroll() {
		var threshold = $(window).width() <= 992 ? 200 : 200;

		var scrolled = $(window).scrollTop() > threshold;

		var subActive = $('.isSubMenu.active').length > 0;
		var childActive = $('.isChildMenu.active').length > 0;

		if (scrolled || subActive || childActive) {
			$('#wrapper-navbar').addClass('scroll-active');
		} else {
			$('#wrapper-navbar').removeClass('scroll-active');
		}
	}

	function lockScroll() {
		$('body').addClass('no-scroll');
	}

	function unlockScroll() {
		$('body').removeClass('no-scroll');
	}

	// Initial check
	checkScroll();

	// Re-run on scroll, resize
	$(window).on('scroll resize', checkScroll);



	// Re-run scroll check
	$(document).on(
		'click',
		'.desktop-nav .hasSub > a, .desktop-menu-expand-wrapper .hasChild > a, .mobile-main-menu .hasSub > a, .mobile-menu-expand-wrapper .hasChild > a, .hasSubReturn, .close-hasSub, .close-allMenus',
		function () {
			setTimeout(checkScroll, 10);
		}
	);

	// mobile trigger (toggle open / close)
	$(document).on('click', '.mobile-menu-trigger', function (e) {
		e.preventDefault();

		var $trigger = $(this);
		var $wrapper = $('.mobile-menu-expand-wrapper');

		// if open → close everything
		if ($wrapper.hasClass('active')) {

			$('.hasSub, .hasChild').removeClass('active');
			$('.isSubMenu, .isChildMenu').removeClass('active');

			$('.desktop-menu-expand-wrapper, .mobile-menu-expand-wrapper').removeClass('active');

			$('.mobile-main-menu').removeClass('active');

			$('#wrapper-navbar').removeClass('scroll-active');

			unlockScroll();

			$trigger.removeClass('fa-xmark').addClass('fa-bars');

			return;
		}

		// open menu
		$wrapper.addClass('active');
		$('.mobile-main-menu').addClass('active');

		$('#wrapper-navbar').addClass('scroll-active');

		lockScroll();

		$trigger.removeClass('fa-bars').addClass('fa-xmark');
	});

	// desktop level 1
	$(document).on('click', '.desktop-nav .hasSub > a', function (e) {
		e.preventDefault();

		var targetId = $(this).attr('href');
		var $target = $('.desktop-menu-expand-wrapper').find(targetId);

		$('.desktop-nav .hasSub').removeClass('active');
		$('.desktop-menu-expand-wrapper .isSubMenu, .desktop-menu-expand-wrapper .isChildMenu').removeClass('active');

		$(this).parent().addClass('active');
		$('.desktop-menu-expand-wrapper').addClass('active');

		if ($target.length) {
			$target.addClass('active');
		}

		lockScroll();
	});

	// mobile level 1
	$(document).on('click', '.mobile-main-menu .hasSub > a', function (e) {
		e.preventDefault();

		var targetId = $(this).attr('href');
		var $target = $('.mobile-menu-expand-wrapper').find(targetId);

		$('.mobile-main-menu .hasSub').removeClass('active');
		$('.mobile-menu-expand-wrapper .isSubMenu, .mobile-menu-expand-wrapper .isChildMenu').removeClass('active');

		$(this).parent().addClass('active');

		if ($target.length) {
			$target.addClass('active');
		}

		$('.mobile-main-menu').removeClass('active');

		lockScroll();
	});

	// desktop level 2
	$(document).on('click', '.desktop-menu-expand-wrapper .hasChild > a', function (e) {
		e.preventDefault();

		var targetId = $(this).attr('href');
		var $target = $('.desktop-menu-expand-wrapper').find(targetId);

		$('.desktop-menu-expand-wrapper .isSubMenu').removeClass('active');
		$('.desktop-menu-expand-wrapper .isChildMenu').removeClass('active');

		if ($target.length) {
			$target.addClass('active');
		}

		lockScroll();
	});

	// mobile level 2
	$(document).on('click', '.mobile-menu-expand-wrapper .hasChild > a', function (e) {
		e.preventDefault();

		var targetId = $(this).attr('href');
		var $target = $('.mobile-menu-expand-wrapper').find(targetId);

		$('.mobile-menu-expand-wrapper .isSubMenu').removeClass('active');
		$('.mobile-menu-expand-wrapper .isChildMenu').removeClass('active');

		if ($target.length) {
			$target.addClass('active');
		}

		$('.mobile-main-menu').removeClass('active');

		lockScroll();
	});

	// back button
	$(document).on('click', '.hasSubReturn', function () {

		$('.isChildMenu').removeClass('active');

		var $activeSub = $('.hasSub.active > a').attr('href');

		if ($activeSub) {
			$('.desktop-menu-expand-wrapper').find($activeSub).addClass('active');
			$('.mobile-menu-expand-wrapper').find($activeSub).addClass('active');
		}

		// do NOT re-show main menu here

		lockScroll();
	});

	// close current menu
	$(document).on('click', '.close-hasSub', function () {

		$('.hasSub').removeClass('active');

		$('.desktop-menu-expand-wrapper .isSubMenu, .desktop-menu-expand-wrapper .isChildMenu').removeClass('active');
		$('.mobile-menu-expand-wrapper .isSubMenu, .mobile-menu-expand-wrapper .isChildMenu').removeClass('active');

		$('.desktop-menu-expand-wrapper, .mobile-menu-expand-wrapper').removeClass('active');

		$('.mobile-main-menu').removeClass('active');

		$('#wrapper-navbar').removeClass('scroll-active');

		unlockScroll();

		$('.mobile-menu-trigger').removeClass('fa-xmark').addClass('fa-bars');
	});

	// close all
	$(document).on('click', '.close-allMenus', function (e) {
		e.preventDefault();

		$('.hasSub, .hasChild').removeClass('active');
		$('.isSubMenu, .isChildMenu').removeClass('active');

		$('.desktop-menu-expand-wrapper, .mobile-menu-expand-wrapper').removeClass('active');

		$('.mobile-main-menu').removeClass('active');

		$('#wrapper-navbar').removeClass('scroll-active');

		unlockScroll();

		$('.mobile-menu-trigger').removeClass('fa-xmark').addClass('fa-bars');
	});






	$('a[href^="#"]:not(.hasSub > a):not(.hasChild > a)').on('click', function (e) {
		var targetId = $(this).attr('href');

		// Ignore empty or just "#"
		if (targetId === '#' || targetId === '') {
			return;
		}

		var $target = $(targetId);

		if ($target.length) {
			e.preventDefault();

			$('html, body').animate(
				{
					scrollTop: $target.offset().top
				},
				600
			);
		}
	});

	// CTA Popup
	function setCookie(name, value) {
		document.cookie = name + "=" + value + "; path=/";
	}

	function getCookie(name) {
		let match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
		return match ? match[2] : null;
	}

	// Show popup if no cookie exists
	if (!getCookie('ctaPopupDismissed')) {
		$('#cta-popup').addClass('active');
	}

	// On dismiss
	$('#dismiss_cta').on('click', function(e) {
		e.preventDefault();
		$('#cta-popup').removeClass('active');
		setCookie('ctaPopupDismissed', 'true');
	});


	// Slick Sliders
	if ($('.award-slider').length) {
		$('.award-slider').slick({
			slidesToShow: 7,
			slidesToScroll: 1,
			arrows: false,
			dots: false,
			infinite: false,
			responsive: [
				{
					breakpoint: 992,
					settings: { slidesToShow: 3 }
				},
				{
					breakpoint: 576,
					settings: { slidesToShow: 3 }
				}
			]
		});
	}

	if ($('.accreditation-slider').length) {
		$('.accreditation-slider').slick({
			slidesToShow: 5,
			slidesToScroll: 1,
			arrows: false,
			dots: false,
			infinite: true,
			autoplay: true,
			autoplaySpeed: 0,
			speed: 20000,
			cssEase: 'linear',
			pauseOnHover: false,
			pauseOnFocus: false,
			centerMode: false,
			responsive: [
				{
					breakpoint: 992,
					settings: { slidesToShow: 3 }
				},
				{
					breakpoint: 576,
					settings: { slidesToShow: 2 }
				}
			]
		});
	}

	$('.our-procedures-slider').slick({
		slidesToShow: 2,
		slidesToScroll: 1,
		infinite: true,
		arrows: true,
		dots: false,
		loop: true,
		prevArrow: $('.procedure-arrow-left'),
		nextArrow: $('.procedure-arrow-right'),
		responsive: [
			{
				breakpoint: 992,
				settings: { slidesToShow: 1 }
			},
			{
				breakpoint: 576,
				settings: { slidesToShow: 1 }
			}
		]
	});

	$('.our-paediatric-procedures-slider').slick({
		slidesToShow: 2,
		slidesToScroll: 1,
		infinite: true,
		arrows: true,
		dots: false,
		loop: true,
		prevArrow: $('.paediatric-procedure-arrow-left'),
		nextArrow: $('.paediatric-procedure-arrow-right'),
		responsive: [
			{
				breakpoint: 992,
				settings: { slidesToShow: 1 }
			},
			{
				breakpoint: 576,
				settings: { slidesToShow: 1 }
			}
		]
	});

	$('.single-treatment-related-treatments-slider').slick({
		slidesToShow: 2,
		slidesToScroll: 1,
		infinite: true,
		arrows: true,
		dots: false,
		loop: true,
		prevArrow: $('.related-treatments-arrow-left'),
		nextArrow: $('.related-treatments-arrow-right'),
		responsive: [
			{
				breakpoint: 992,
				settings: { slidesToShow: 1 }
			},
			{
				breakpoint: 576,
				settings: { slidesToShow: 1 }
			}
		]
	});

	$('.conditions-treated-slider').slick({
		slidesToShow: 4,
		slidesToScroll: 1,
		infinite: true,
		arrows: true,
		dots: false,
		loop: true,
		prevArrow: $('.condition-arrow-left'),
		nextArrow: $('.condition-arrow-right'),
		responsive: [
			{
				breakpoint: 992,
				settings: { slidesToShow: 1 }
			},
			{
				breakpoint: 576,
				settings: { slidesToShow: 1 }
			}
		]
	});

	$('.single-treatment-conditions-treated-slider').slick({
		slidesToShow: 4,
		slidesToScroll: 1,
		infinite: true,
		arrows: true,
		dots: false,
		loop: true,
		prevArrow: $('.st-condition-arrow-left'),
		nextArrow: $('.st-condition-arrow-right'),
		responsive: [
			{
				breakpoint: 992,
				settings: { slidesToShow: 1 }
			},
			{
				breakpoint: 576,
				settings: { slidesToShow: 1 }
			}
		]
	});

	$('.patient-education-slider').slick({
		slidesToShow: 2,
		slidesToScroll: 1,
		infinite: true,
		arrows: true,
		dots: false,
		loop: true,
		prevArrow: $('.patient-education-arrow-left'),
		nextArrow: $('.patient-education-arrow-right'),
		responsive: [
			{
				breakpoint: 992,
				settings: { slidesToShow: 1 }
			},
			{
				breakpoint: 576,
				settings: { slidesToShow: 1 }
			}
		]
	});

	$('.single-treatment-video-slider').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		infinite: true,
		arrows: true,
		dots: false,
		loop: true,
		prevArrow: $('.treatment-video-arrow-left'),
		nextArrow: $('.treatment-video-arrow-right'),
	});

	$('.seo-landing-video-slider').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		infinite: true,
		arrows: true,
		dots: false,
		loop: true,
		prevArrow: $('.seo-video-arrow-left'),
		nextArrow: $('.seo-video-arrow-right'),
	});

	$('.single-treatment-before-afters-slider').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		infinite: true,
		arrows: true,
		dots: false,
		loop: true,
		fade: true,
		cssEase: 'linear',
		swipe: false,
		prevArrow: $('.treatment-before-afters-arrow-left'),
		nextArrow: $('.treatment-before-afters-arrow-right'),
	});

	$('.seo-landing-before-afters-slider').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		infinite: true,
		arrows: true,
		dots: false,
		loop: true,
		fade: true,
		cssEase: 'linear',
		swipe: false,
		prevArrow: $('.seo-before-afters-arrow-left'),
		nextArrow: $('.seo-before-afters-arrow-right'),
	});

	$('.testimonial-slider').slick({
		slidesToShow: 4,
		slidesToScroll: 1,
		arrows: true,
		dots: false,
		infinite: false,
		prevArrow: $('.reviews-arrow-left'),
		nextArrow: $('.reviews-arrow-right'),
		responsive: [
			{
				breakpoint: 992,
				settings: { slidesToShow: 2 }
			},
			{
				breakpoint: 576,
				settings: { slidesToShow: 1 }
			}
		]
	});

	var $slider = $('.video-slider');
	var $descriptions = $('.video-description');

	$slider.slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: true,
		adaptiveHeight: false,
		infinite: true,
		fade: true,
		cssEase: 'linear',
		swipe: false,
		prevArrow: $('.video-arrow-left'),
		nextArrow: $('.video-arrow-right')
	});

	$descriptions.hide().first().show();

	$slider.on('afterChange', function(event, slick, currentSlide){
		$descriptions.hide().eq(currentSlide).show();
	});

	$('.custom-reviews-reviews-slider').slick({
		slidesToShow: 4,
		slidesToScroll: 1,
		arrows: true,
		prevArrow: $('.custom-reviews-slider-arrow-left'),
		nextArrow: $('.custom-reviews-slider-arrow-right'),
		responsive: [
			{
				breakpoint: 991,
				settings: {
					slidesToShow: 1
				}
			}
		]
	});


	// Select2 Set Class & PLaceholder Text
	// jQuery(function ($) {
	// 	var $select = $('.init-select2 select');
	//
	// 	if (!$select.length) {
	// 		return;
	// 	}
	//
	// 	$select.select2({
	// 		width: '100%',
	// 		placeholder: 'Select a treatment',
	// 		allowClear: true
	// 	});
	//
	// 	$select.on('change', function () {
	// 		var url = $(this).val();
	//
	// 		if (url && url !== '') {
	// 			window.location.href = url;
	// 		}
	// 	});
	// });


	// CTA Popup
	function setCookie(name, value) {
		document.cookie = name + "=" + value + "; path=/";
	}

	function getCookie(name) {
		let match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
		return match ? match[2] : null;
	}

	// Show popup if no cookie exists
	if (!getCookie('ctaPopupDismissed')) {
		$('#cta-popup').addClass('active');
	}

	// On dismiss
	$('#dismiss_cta').on('click', function(e) {
		e.preventDefault();
		$('#cta-popup').removeClass('active');
		setCookie('ctaPopupDismissed', 'true');
	});


	$('.paediatric-procedure-arrow-left, .paediatric-procedure-arrow-right').hide();

	$('.procedure-toggle').on('click', function (e) {
		e.preventDefault();

		const target = $(this).data('target');

		const $adult = $('#our-procedures-adult-procedures-slider');
		const $paediatric = $('#our-procedures-paediatric-procedures-slider');

		// Hide both sliders
		$adult.hide();
		$paediatric.hide();

		// Show correct slider
		$('#' + target).show().slick('setPosition');

		// Toggle arrows
		if (target === 'our-procedures-adult-procedures-slider') {
			$('.procedure-arrow-left, .procedure-arrow-right').show();
			$('.paediatric-procedure-arrow-left, .paediatric-procedure-arrow-right').hide();
		} else {
			$('.procedure-arrow-left, .procedure-arrow-right').hide();
			$('.paediatric-procedure-arrow-left, .paediatric-procedure-arrow-right').show();
		}

		// Button states
		$('.procedure-toggle')
			.removeClass('button-gold-filled active-btn')
			.addClass('button-white-filled');

		$(this)
			.removeClass('button-white-filled')
			.addClass('button-gold-filled active-btn');
	});


	$('.patient-guide-category-filter select, .patient-guide-date-filter select').select2({
		width: '100%',
		minimumResultsForSearch: Infinity
	});




	// Run on page load
// 	updateSpecialityHeight();
//
// 	// Run on window resize
// 	$(window).on('resize', function() {
// 		updateSpecialityHeight();
// 	});

});
